import * as React from 'react'
import { styled } from './styled-components'
import { Utils } from './Utils'

interface IProps {
  small?: boolean
  children?: React.ReactNode
  link?: string
  className?: string
}

export const InfoTooltip = (props: IProps) => {
  const [visible, setVisible] = React.useState(false)

  let button = (<InfoButton
    small={props.small}
    onMouseEnter={() => props.children && setVisible(true)}
    onMouseLeave={() => props.children && setVisible(false)} />)
  if (props.link) {
    button = <a href={props.link} target="_blank">{button}</a>
  }
  return (<Container className={props.className}>
    {button}
    {visible && <Tooltip>{props.children}</Tooltip>}
  </Container>)
}

const Container = styled.div`
  position: relative;
`

const InfoButton = styled.div<{ small?: boolean }>`
  position: relative;
  width: ${props => props.small ? '20px' : '40px'};
  height: ${props => props.small ? '20px' : '40px'};
  mask: url('${Utils.getAssetPath('/assets/icons/info-button.svg')}') no-repeat center center;
  mask-size: cover;
  background: ${props => props.theme.primaryColor};   
  margin-left: 10px;  
`

const Tooltip = styled.div`
  border-radius: 3px;
  background: ${props => props.theme.primaryColor};
  color: white;
  font-size: 12px;
  padding: 10px;
  line-height: 18px;
  position: absolute;
  bottom: 110%;
  left: 80%;
  text-align: center;
  width: 200px;
  max-width: 200px;
`
